
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '@/contexts/LanguageContext';
import DesktopNavigation from './navigation/DesktopNavigation';
import MobileNavigation from './navigation/MobileNavigation';
import Logo from './navigation/Logo';
import { useNavigationUtils } from '@/hooks/useNavigationUtils';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { currentLanguage } = useLanguage();
  const location = useLocation();
  const { isWhyFutureLevelActive } = useNavigationUtils();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Close mobile menu when route changes
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Check if services section is active
  const isServicesActive = location.pathname.includes('/services') || 
                           location.pathname.includes('/leistungen') ||
                           location.pathname.includes('/servizi') ||
                           location.pathname.includes('/publicites-medias-sociaux');

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || isMenuOpen
          ? 'bg-[#1A1F2C]/95 backdrop-blur-md shadow-md shadow-purple-800/20 py-2' 
          : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Logo scrolled={scrolled} />

        {/* Desktop Navigation */}
        <DesktopNavigation isServicesActive={isServicesActive} />

        <div className="flex items-center space-x-4">
          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>
          <button 
            onClick={toggleMenu} 
            className="md:hidden text-purple-400 hover:text-purple-300 transition-colors relative group"
            aria-label="Toggle menu"
          >
            <div className="relative">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              <span className="absolute -inset-2 rounded-full bg-purple-600/0 group-hover:bg-purple-600/10 transition-colors duration-300"></span>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <MobileNavigation 
        isMenuOpen={isMenuOpen} 
        setIsMenuOpen={setIsMenuOpen} 
        isServicesActive={isServicesActive} 
      />
    </header>
  );
};

export default Header;
